let config: {
  appKey: string;
  appSecret: string;
  apiDomain: string;
  rootDomain: string;
}

if (process.env.NODE_ENV === 'production') {
  config = {
    appKey: 'talkmateVersion',
    appSecret: '5EAE76C6323C85D2E35D4817020D84C9',
    apiDomain: 'https://wapi.talkmate.com',
    rootDomain: 'https://learn.talkmate.com'
  }
} else {
  config = {
    appKey: 'talkmateVersion',
    appSecret: '5EAE76C6323C85D2E35D4817020D84C9',
    apiDomain: 'https://wapi.talkmate.com',
    rootDomain: 'https://learn.talkmate.com'
    // appKey: 'talkmateVersion',
    // appSecret: 'E6DAC3DC3514681FC922ECE1B0CF06EB',
    // apiDomain: 'http://dev.api.talkmate.com',
    // rootDomain: 'http://test-learn.talkmate.com'
  }
}

export default config
